<template>
  <div>
    <SearchForm @change="fetchData" ref="search"></SearchForm>
    <el-table
      :data="models"
      :border="border"
      style="width: 100%"
      :row-class-name="tableRowClassName"
      @sort-change="handleSort"
    >
      <el-table-column type="index" width="50" :index="index"></el-table-column>
      <el-table-column prop="id" label="ID" width="70" sortable="custom"></el-table-column>
      <el-table-column prop="level" label="等级" sortable="custom"></el-table-column>
      <el-table-column prop="text" label="标题" sortable="custom"></el-table-column>
      <el-table-column prop="pinyin" label="拼音" sortable="custom"></el-table-column>
      <el-table-column label="词性">
        <template v-slot="item">
          {{item.row.grammars.map(n => n.name).join('、')}}
        </template>
      </el-table-column>
      <el-table-column prop="memo" label="内部备注"></el-table-column>
      <el-table-column fixed="right" width="100" align="right">
        <template #default="column">
          <slot name="operate" :row="column.row"></slot>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[5, 10, 20, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import SearchForm from '@/components/SearchForm'

export default {
  name: 'WordInlineList',
  components: { SearchForm },
  props: {
    border: Boolean,
    searchs: Object,
    selection: [Array, Number]
  },
  data () {
    return {
      models: [],
      total: 0,
      index: 1,
      currentPage: 1,
      pageSize: 5,
      sort: '-id',
    }
  },
  watch: {
    searchs() {
      this.initSearch(this.searchs)
    }
  },
  mounted () {
    this.initSearch(this.searchs)
  },
  methods: {
    fetchData () {
      let params = {
        "filter[and][0][status]": 1,
        page: this.currentPage,
        'per-page': this.pageSize,
        sort: this.sort
      }
      if (this.$refs.search) {
        Object.assign(params, {
          "filter[and][0][level]": this.$refs.search.level || null,
          "filter[and][0][num]": this.$refs.search.num || null,
          "filter[and][1][or][0][text][regexp]": this.normalRegexpSearch(this.$refs.search.search),
          "filter[and][1][or][1][pinyin][like]": this.$refs.search.search || null
        })
      }
      this.$http.get(this.$urls.word_list, { params }).then(res => {
        this.total = Number.parseInt(res.headers['x-pagination-total-count'])
        this.currentPage = Number.parseInt(res.headers['x-pagination-current-page'])
        this.models = res.data
        this.index = (this.currentPage - 1) * this.pageSize + 1
        this.$emit('loaded')
      })
    },
    handleSort ({column, prop, order}) {
      this.sort = order === 'ascending' ? prop : ('-' + prop)
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchData()
    },
    initSearch(values) {
      this.$refs.search.initSearch(values || {})
    },
    normalRegexpSearch(text) {
      if (text) {
        return text.replace(/\s+/g, '').split('').join(' ?')
      }
      return null
    },
    tableRowClassName({row, rowIndex}) {
      if (this.selection) {
        if (typeof this.selection === 'number') {
          if (row.id === this.selection) {
            return 'checked-row'
          }
        } else if(Array.isArray(this.selection)) {
          if (this.selection.includes(row.id)) {
            return 'checked-row'
          }
        }
      }
      return ''
    }
  }
}
</script>